var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _g4, _path7, _path8, _g5, _path9, _path10, _g6, _path11, _path12, _g7, _path13, _g8, _path14, _g9, _path15, _g10, _path16, _path17, _g11, _path18, _g12, _path19, _g13, _path20, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopperIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 46,
    viewBox: "0 0 79 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.70911 16.0523V5.44893C12.1567 1.84086 22.1924 0 32.3017 0H39.3965V16.0523H2.70911Z",
    fill: "#FFCE00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_115_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 38,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70911 16.0523V5.44893C12.1567 1.84086 22.1924 0 32.3017 0H39.3965V16.0523H2.70911Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_115_303)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.30475 10.861L39.3965 10.5297V12.7387H1.67981V10.6769L2.30475 10.861Z",
    fill: "#C46600"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_115_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 38,
    height: 17
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70911 16.0523V5.44893C12.1567 1.84086 22.1924 0 32.3017 0H39.3965V16.0523H2.70911Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_115_303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3965 3.12939H32.8898C28.3314 3.12939 23.8466 4.16027 19.7294 6.1484V8.98331H39.3965V3.12939Z",
    fill: "#E00AB8"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7163 16.0523V5.44893C66.3422 1.84086 56.4168 0 46.4178 0H39.3965V16.0523H75.7163Z",
    fill: "#FFE578"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_115_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 0,
    width: 37,
    height: 17
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7163 16.0523V5.44893C66.3422 1.84086 56.4168 0 46.4178 0H39.3965V16.0523H75.7163Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_115_303)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M76.1575 10.8611L39.0657 10.5665V12.7387H76.7824V10.677L76.1575 10.8611Z",
    fill: "#C46600"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_115_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 0,
    width: 37,
    height: 17
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7163 16.0523V5.44893C66.3422 1.84086 56.4168 0 46.4178 0H39.3965V16.0523H75.7163Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_115_303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3965 3.12939H45.9032C50.4615 3.12939 54.9464 4.16027 59.0636 6.1484V8.98331H39.3965V3.12939Z",
    fill: "#FF4AE5"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.39314 14.2482L39.3965 45.4691V11.671L1.05484 12.3337C0.0622984 12.3705 -0.378839 13.6223 0.39314 14.2482Z",
    fill: "#FFCE00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_115_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 40,
    height: 35
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.39314 14.2482L39.3965 45.4691V11.671L1.05484 12.3337C0.0622984 12.3705 -0.378839 13.6223 0.39314 14.2482Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_115_303)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M-0.158325 12.8491L39.3964 43.0391L39.4332 47.6045L0.0254794 14.7268L-0.158325 12.8491Z",
    fill: "#C46600"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3998 14.2482L39.3965 45.4323V11.6342L77.7749 12.3337C78.7674 12.3705 79.1718 13.6223 78.3998 14.2482Z",
    fill: "#FFE578"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_115_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 11,
    width: 40,
    height: 35
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3998 14.2482L39.3965 45.4323V11.6342L77.7749 12.3337C78.7674 12.3705 79.1718 13.6223 78.3998 14.2482Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_115_303)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M78.988 12.8491L39.2127 43.1496L39.1759 47.6781L79.0247 14.6163L78.988 12.8491Z",
    fill: "#DD7003"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50986 15.905L39.3965 39.8362V13.9537L9.98775 14.4692C9.25253 14.4692 8.92168 15.4264 9.50986 15.905Z",
    fill: "#E00AB8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_115_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 13,
    width: 31,
    height: 27
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50986 15.905L39.3965 39.8362V13.9537L9.98775 14.4692C9.25253 14.4692 8.92168 15.4264 9.50986 15.905Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_115_303)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.7359 31.2946L10.9803 17.0832C10.9803 17.0832 36.6395 31.8469 36.6395 31.6628C36.6395 31.4787 39.3965 16.4941 39.3965 16.4941V40.1675L28.7359 31.2946Z",
    fill: "#FFDCFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_115_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 13,
    width: 31,
    height: 27
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50986 15.905L39.3965 39.8362V13.9537L9.98775 14.4692C9.25253 14.4692 8.92168 15.4264 9.50986 15.905Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_115_303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9803 17.0831L38.2937 37.6639L39.3965 23.4893L39.4333 40.4252L10.9803 17.0831Z",
    fill: "#FFDCFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_115_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 13,
    width: 31,
    height: 27
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50986 15.905L39.3965 39.8362V13.9537L9.98775 14.4692C9.25253 14.4692 8.92168 15.4264 9.50986 15.905Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_115_303)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M34.1764 26.6188L33.4412 23.6366L29.7651 20.3599L31.1988 23.9679L34.1764 26.6188Z",
    fill: "#FFDCFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_115_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 13,
    width: 31,
    height: 27
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50986 15.905L39.3965 39.8362V13.9537L9.98775 14.4692C9.25253 14.4692 8.92168 15.4264 9.50986 15.905Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_115_303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7651 20.3599L34.1764 26.6188L31.1988 23.9679L29.7651 20.3599Z",
    fill: "#FFDCFC"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2831 15.905L39.3965 39.8362V13.9537L68.8052 14.4692C69.5404 14.4692 69.8713 15.4264 69.2831 15.905Z",
    fill: "#FF4AE5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_115_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 13,
    width: 31,
    height: 27
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2831 15.905L39.3965 39.8362V13.9537L68.8052 14.4692C69.5404 14.4692 69.8713 15.4264 69.2831 15.905Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_115_303)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50.0204 31.2946L67.7759 17.0832C67.7759 17.0832 42.1168 31.8469 42.1168 31.6628C42.1168 31.4787 39.3597 16.4941 39.3597 16.4941V39.8362L50.0204 31.2946Z",
    fill: "#FFDCFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_115_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 13,
    width: 31,
    height: 27
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2831 15.905L39.3965 39.8362V13.9537L68.8052 14.4692C69.5404 14.4692 69.8713 15.4264 69.2831 15.905Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_115_303)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M44.2856 26.9501L45.6091 23.4893L50.0204 20.3599L47.8147 24.4466L44.2856 26.9501Z",
    fill: "#FFDCFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_115_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 13,
    width: 31,
    height: 27
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2831 15.905L39.3965 39.8362V13.9537L68.8052 14.4692C69.5404 14.4692 69.8713 15.4264 69.2831 15.905Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_115_303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7487 23.7839L50.0204 20.3599L47.9986 24.1152L44.4327 26.6188L46.7487 23.7839Z",
    fill: "#FFDCFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_115_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 13,
    width: 31,
    height: 27
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2831 15.905L39.3965 39.8362V13.9537L68.8052 14.4692C69.5404 14.4692 69.8713 15.4264 69.2831 15.905Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_115_303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3965 23.4894L40.4626 37.5535L63.8793 20.2495L39.3965 39.8362V23.4894Z",
    fill: "#FFDCFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopperIcon);
export default __webpack_public_path__ + "static/media/stopper-icon.cb9ddd1cf36f81ace2c04ad4884d4e80.svg";
export { ForwardRef as ReactComponent };